import { useEffect } from 'react'

export const useDocumentTitle = (title: string | undefined) => {
  if (typeof title === 'undefined') {
    return
  }

  useEffect(() => {
    document.title = title
  }, [title])
}
